import HeroSection from './components/HeroSection';
import TrustStatsBar from './components/TrustStatsBar';
import WhyMeowCentral from './components/WhyMeowCentral';
import BestDealsStrip from './components/BestDealsStrip';
import CatQuizSection from './components/CatQuizSection';
import DailyCatChallenge from './components/DailyCatChallenge';
import HomeProductSection from './components/HomeProductSection';
import FastVideoBrowser from './components/FastVideoBrowser';
import { CatPollSection } from './components/CatPollSection';
import CatStorySection from './components/CatStorySection';
import MeowNewsletterStrip from './components/MeowNewsletterStrip';
import CompactAdoptionTeaser from './components/CompactAdoptionTeaser';
import CompactBlogTeaser from './components/CompactBlogTeaser';
import FeaturedInStrip from './components/FeaturedInStrip';
import WelcomeEmailPopup from './components/WelcomeEmailPopup';
import StickyEmailBar from './components/StickyEmailBar';
import ScrollToTop from './components/ScrollToTop';
import AffiliateDisclosure from '@/components/feature/AffiliateDisclosure';
import SEOHead from '@/components/feature/SEOHead';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'MeowCentral',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
    description: 'MeowCentral — the ultimate cat website for kitten videos, cat care guides, adoption resources, and premium cat products.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MeowCentral',
    url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
    logo: 'https://public.readdy.ai/ai/img_res/37bc7df8-b441-456a-b64e-dfe2e72930b6.png',
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'hello@catsite.com',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="MeowCentral - Cutest Kittens, Videos & Cat Products"
        description="MeowCentral is the greatest cat website ever made! Watch endless adorable kitten videos, shop premium cat products, read cat blogs, and join the purr-fect community. A one-stop shop for everything cats."
        keywords="cute kittens, cat videos, cat products, cat blog, adorable cats, funny cat videos, cat toys, cat accessories"
        canonical="/"
        schema={homeSchema}
      />
      <WelcomeEmailPopup />
      <StickyEmailBar />
      <AffiliateDisclosure variant="banner" />
      <HeroSection />
      <TrustStatsBar />
      <WhyMeowCentral />
      <BestDealsStrip />
      <CatQuizSection />
      <DailyCatChallenge />
      <CatPollSection />
      <HomeProductSection />
      <FastVideoBrowser />
      <CatStorySection />
      <FeaturedInStrip />
      <MeowNewsletterStrip />
      <CompactAdoptionTeaser />
      <CompactBlogTeaser />
      <ScrollToTop />
    </div>
  );
}
